import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ExpandedPanel } from 'src/app/models/in-out-panel/expanded-panel-object.model';
import { MatDialog } from '@angular/material';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css']
})
export class PanelComponent implements OnInit {

  @Input() editable: boolean;
  _characteristics: CharacteristicsObject;
  @Input()
  get characteristics(): any {
    return this._characteristics;
  }
  set characteristics(value: any) {
    this._characteristics = value;
    this.ngOnInit();
  }
  @Output() diffCharacteristicsEvent = new EventEmitter<CharacteristicsObject>();

  expandedPanel: ExpandedPanel;
  expandedInput: boolean;
  expandedOutput: boolean;

  currentCharacteristics: CharacteristicsObject;
  private diffCharacteristics: CharacteristicsObject;
  private originalCharacteristics: CharacteristicsObject;

  disabledReset: boolean;

  constructor(public dialog: MatDialog) {
    this.expandedPanel = ExpandedPanel.create();
    this.expandedInput = false;
    this.expandedOutput = false;
  }

  ngOnInit() {
    this.currentCharacteristics = CharacteristicsObject.create();
    this.diffCharacteristics = CharacteristicsObject.create();
    this.originalCharacteristics = this.currentCharacteristics.clone();
    this.disabledReset = true;

    if (this._characteristics) {
      this.currentCharacteristics = this._characteristics;
      this.originalCharacteristics = this.currentCharacteristics.clone();
    }

  }

  public resetCharacteristics() {
    this.currentCharacteristics = this.originalCharacteristics.clone();
    this.disabledReset = true;
    this.diffCharacteristics.inputCharacteristics.length = 0;
    this.diffCharacteristics.outputCharacteristics.length = 0;
    this.diffCharacteristicsEvent.emit(this.diffCharacteristics);
  }

  onDiffOutputCharacteristics($event: Array<CharacteristicObject>) {
    this.disabledReset = $event.length === 0;
    this.diffCharacteristics.outputCharacteristics = $event;
    this.diffCharacteristicsEvent.emit(this.diffCharacteristics);
  }

  onDiffInputCharacteristics($event: Array<CharacteristicObject>) {
    this.disabledReset = $event.length === 0;
    this.diffCharacteristics.inputCharacteristics = $event;
    this.diffCharacteristicsEvent.emit(this.diffCharacteristics);
  }

  expandInput($event) {
    this.expandedInput = $event;
    this.expandedPanel.setInputExpand($event);
    if ($event && this.expandedOutput) {
      this.expandedOutput = !$event;
      this.expandedPanel.setOutputExpand(!$event);
    }
  }

  expandOutput($event) {
    this.expandedOutput = $event;
    this.expandedPanel.setOutputExpand($event);
    if ($event && this.expandedInput) {
      this.expandedInput = !$event;
      this.expandedPanel.setInputExpand(!$event);
    }
  }
}